import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "../../app/hook";
import { handleSetTemplateId, wizardState } from "./botSlice";
import { McBotFaceType } from "./types";
import { BiLogoLinkedinSquare } from "react-icons/bi";

const VideoScenarioTemplates = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const wizard = useAppSelector(wizardState);

  const { setValue } = useFormContext();

  useEffect(() => {
    dispatch(handleSetTemplateId(1));

    setValue("template_id", 1);
  }, []);

  return (
    <div className="md:tw-flex ">
      <div className="tw-grid  xxl:tw-grid-cols-5 xl:tw-grid-cols-4 lg:tw-grid-cols-3 md:tw-grid-cols-2 tw-grid-cols-1 tw-gap-4">
        <div
          className={`tw-relative  tw-w-full tw-p-4 md:tw-h-full tw-bg-white tw-shrink tw-shadow tw-flex-col tw-justify-start tw-items-start tw-border-solid tw-rounded-lg md:tw-flex-1 ${
            wizard.isInEditMode ? "tw-cursor-not-allowed" : ""
          } ${
            (wizard.bot_config as McBotFaceType).template_id === 1
              ? "tw-border-4 tw-border-blue-500"
              : "tw-border-4 tw-border-transparent"
          }  ${
            wizard.isInEditMode &&
            (wizard.bot_config as McBotFaceType).template_id !== 1
              ? "tw-hidden"
              : "tw-inline-flex"
          } ${wizard.isInEditMode ? "tw-cursor-default" : ""}`}
          onClick={() => {
            if (!wizard.isInEditMode) {
              dispatch(handleSetTemplateId(1));
              setValue("template_id", 1);
            }
          }}
          onKeyDown={() => {
            if (!wizard.isInEditMode) {
              dispatch(handleSetTemplateId(1));
              setValue("template_id", 1);
            }
          }}
          role="button"
          aria-label="bot-selector"
          tabIndex={0}
        >
          {wizard.isInEditMode &&
            (wizard.bot_config as McBotFaceType).template_id !== 1 && (
              <div className="tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-bottom-0 tw-bg-gray-200 tw-bg-opacity-50" />
            )}
          <img
            src="https://cdn.1cdn.app/application/LOUISEBOT/25021720384717_from_scratch_min.png"
            alt="template-scenario"
            className="tw-w-full tw-object-cover  tw-h-[120px] tw-self-stretch tw-rounded-lg tw-flex tw-flex-col tw-justify-center tw-items-center "
          />
          <div className=" tw-self-stretch  tw-pt-3 tw-rounded-bl-lg tw-rounded-br-lg tw-flex-col tw-justify-start tw-items-start tw-gap-3 flex">
            <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-3 tw-flex">
              <div className=" tw-h-[80px] tw-w-full">
                <div className="tw-flex tw-items-center tw-justify-between tw-w-full">
                  <div className="tw-self-stretch tw-text-gray-900 text-base font-normal tw-font-['Lexend'] tw-leading-normal">
                    {t("Wizard/VideoScenarioTemplates/key3")}
                  </div>
                  <div className="tw-text-gray-400 tw-text-xs tw-font-normal tw-font-['Lexend'] tw-leading-none"></div>
                </div>
                <div className="tw-self-stretch tw-text-gray-500 tw-text-xs tw-font-normal tw-font-['Lexend']  tw-mt-1">
                  {t("Wizard/VideoScenarioTemplates/key4")}
                </div>
              </div>
              <div className="tw-h-[30px]  tw-flex tw-items-center tw-justify-between tw-w-full">
                <div className="tw-flex tw-items-center tw-gap-2">
                  <img
                    src="https://cdn.1cdn.app/application/LOUISEBOT/23091707385795_Logo_colorful.svg"
                    alt="template-scenario"
                    className="tw-w-7 tw-h-7 tw-rounded-full"
                  />
                  <div className="tw-text-gray-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
                    Louise
                  </div>
                </div>
                <a
                  className="tw-cursor-pointer"
                  href="https://www.linkedin.com/company/louisebot/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <BiLogoLinkedinSquare className="tw-w-4 tw-h-4 tw-text-gray-400" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoScenarioTemplates;
